var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseScreen',{staticClass:"embedForm",attrs:{"name":"embedForm"}},[_c('div',{staticClass:"embedForm__inner",attrs:{"id":"embedForm"}})])}
var staticRenderFns = []

export { render, staticRenderFns }